module.exports = __webpack_public_path__ + "img/map-1.5155abf9.png";